import { BillingCycle } from "./constants";
import { BillingCycleType } from "./types";

/** Complete 年付现价 299.99 时的划线价（对标月付 ×12） */
export const COMPLETE_YEARLY_STRIKETHROUGH_PRICE = 479.88;
const COMPLETE_YEARLY_PROMO_DISPLAY_PRICE = 299.99;

const LEGACY_STRIKETHROUGH_FACTOR = 0.63;

/**
 * Complete 付费卡划线价：月付不展示；年付 299.99 用 479.88；其余年付仍 price/0.63
 */
export const resolveCompleteStrikethroughPrice = (
  price: number,
  billingCycle: BillingCycleType,
): number | undefined => {
  if (billingCycle === BillingCycle.MONTH) {
    return undefined;
  }
  if (billingCycle === BillingCycle.YEAR) {
    if (Number(price.toFixed(2)) === COMPLETE_YEARLY_PROMO_DISPLAY_PRICE) {
      return COMPLETE_YEARLY_STRIKETHROUGH_PRICE;
    }
    return price / LEGACY_STRIKETHROUGH_FACTOR;
  }
  if (billingCycle === BillingCycle.WEEK) {
    return Math.ceil(price);
  }
  return undefined;
};

export const resolveCompleteDiscountPercent = (
  price: number,
  referenceOriginal: number | undefined,
): number => {
  if (!referenceOriginal || referenceOriginal <= price) {
    return 0;
  }
  return Math.round((1 - price / referenceOriginal) * 100);
};
